import { render, staticRenderFns } from "./rich-text-widget.vue?vue&type=template&id=61a9298e&scoped=true"
import script from "./rich-text-widget.vue?vue&type=script&lang=js"
export * from "./rich-text-widget.vue?vue&type=script&lang=js"
import style0 from "./rich-text-widget.vue?vue&type=style&index=0&id=61a9298e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a9298e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61a9298e')) {
      api.createRecord('61a9298e', component.options)
    } else {
      api.reload('61a9298e', component.options)
    }
    module.hot.accept("./rich-text-widget.vue?vue&type=template&id=61a9298e&scoped=true", function () {
      api.rerender('61a9298e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/rich-text-widget.vue"
export default component.exports